module.exports = __webpack_public_path__ + "static/media/1.10.8201a375.png";